import React from 'react';
import { Truck, Recycle, Building2, Home, Trash2, PackageOpen} from 'lucide-react';


const services = [
  {
    title: "Residential Moving",
    description: "We provide reliable and efficient residential moving services, ensuring your household items are transported safely to your new home. From loading to unloading, we handle every aspect of your move with care and professionalism.",
    Icon: Home,
  },
  {
    title: "Relocation",
    description: "Whether you're moving across town or the country, our relocation services are prepared to meet your needs. We offer thorough planning and coordination to make your move as stress-free as possible.",
    Icon: Truck,
  },
  {
    title: "Commercial Moving",
    description: "We handle office equipment, furniture, and all sensitive documents with extreme caution, ensuring a smooth transition to your new commercial space.",
    Icon: Building2,
  },
  {
    title: "Recycling",
    description: "We ensure that your recyclable materials are properly sorted and disposed of in an environmentally friendly manner. We handle everything, from collection to delivery to the appropriate recycling facilities.",
    Icon: Recycle,
  },
  {
    title: "Junk Removal",
    description: "Our junk removal services make decluttering easy and stress-free. Whether it's old furniture, appliances, or general household waste, we handle the heavy lifting and ensure proper disposal or donation, leaving your space clean and organized.",
    Icon: Trash2,
  },
  {
    title: "Packing",
    description: "Our professional packing services ensure that your belongings are securely packed for a safe move. We use high-quality materials and techniques to protect your items during transit, giving you peace of mind throughout the moving process.",
    Icon: PackageOpen,
  },
];
const ServiceCard = ({ title, description, Icon }) => (
  <div className="bg-white rounded-xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300">
    <div className="bg-red-50 w-12 h-12 md:w-16 md:h-16 rounded-lg flex items-center justify-center mb-4 md:mb-6">
      <Icon className="h-6 w-6 md:h-8 md:w-8 text-red-600" />
    </div>
    <h3 className="text-xl md:text-2xl font-semibold mb-3 md:mb-4 text-gray-800">{title}</h3>
    <p className="text-sm md:text-base text-gray-600 leading-relaxed">{description}</p>
  </div>
);

const Services = () => (
  <>
    <section id="services" className="py-12 md:py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-3 md:mb-4">Our Services</h2>
        <div className="h-1 w-20 md:w-24 bg-red-600 mx-auto mb-8 md:mb-12"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>
      </div>
    </section>
    <section id="reviews" className="py-16 bg-gray-100">
      <h2 className="text-4xl font-bold text-center mb-4">Our Reviews</h2>
      <div className="h-1 w-24 bg-red-600 mx-auto mb-12"></div>
      <div className="elfsight-app-eb8f99f3-01fa-4e97-99cd-f16459b29305" data-elfsight-app-lazy />
    </section>
  </>
);
export default Services;